// extracted by mini-css-extract-plugin
module.exports = {"image-container":"style-m__image-container__3DAi4","text":"style-m__text__3p7Bm"};